import { useMemo } from 'react'

import type { Box } from '@library/menu-service/queries/menuApiBoxes/types'

import { useBoxes } from './useBoxes'

const DEFAULT_MIN_RECIPES = 2

export const useMinRecipesForPortion = (numberOfPortions = 2) => {
  const { boxes } = useBoxes()

  return useMemo(() => {
    const filteredBoxes = boxes.filter((box: Box) => box.numberOfPortions === numberOfPortions)
    const recipeCounts = filteredBoxes.map((box: Box) => box.numberOfRecipes)
    const hasRecipeCounts = recipeCounts?.length > 0

    return hasRecipeCounts ? Math.min(...recipeCounts) : DEFAULT_MIN_RECIPES
  }, [boxes, numberOfPortions])
}
